import {Controller} from "@hotwired/stimulus"

// Reloads a turbo-frame from a URL built off the selected value. Used for the
// service -> permission/role cascade in the grant modals: changing the service
// re-renders the dependent select scoped to that service.
export class SelectNavigateController extends Controller {
	static values = {
		url: String,
		param: {type: String, default: "service_id"},
		frame: String,
	}

	go() {
		const url = new URL(this.urlValue, window.location.origin)
		if (this.element.value) url.searchParams.set(this.paramValue, this.element.value)

		const frame = document.getElementById(this.frameValue)
		if (frame) {
			frame.src = url.toString()
		} else {
			Turbo.visit(url.toString(), {frame: this.frameValue})
		}
	}
}
